import { Component, OnInit, Input } from '@angular/core';
import { DownloadLocalFileService } from 'src/app/services/download-local-file.service';
import { StudyReportAttachFileService } from 'src/app/services/study-report-attach-file/study-report-attach-file.service';
import { NotificationToastService } from '../../../services/notification-toast.service';

@Component({
  selector: 'app-study-report-attach-file',
  templateUrl: './study-report-attach-file.component.html',
  styleUrls: ['./study-report-attach-file.component.css']
})
export class StudyReportAttachFileComponent implements OnInit {

  @Input() studyReportId: number;
  loading: boolean;
  hideElement = true;
  files: ReportAttachFile[] = [];

  constructor(
    private notification: NotificationToastService,
    private downloadLocalFileService: DownloadLocalFileService,
    private afService: StudyReportAttachFileService ) { }

  async ngOnInit() {
    await this.loadFiles();
  }

  private async loadFiles() {
    try {
      this.loading = true;
      this.files = await this.afService
        .getByStudyReportId(this.studyReportId);
    } catch (err) {
      this.notification.error(JSON.stringify(err.error), "Archivos adjuntos");
    } finally {
      this.loading = false;
    }
  }

  async delete(file: ReportAttachFile) {
    try {
      file.Loading = true;
      await this.afService.delete(file.Id);
      const index = this.files.indexOf(file);
      this.files.splice(index, 1);
    } catch (err) {
      this.notification.error(JSON.stringify(err.error), "Archivos adjuntos");
    } finally {
      file.Loading = false;
    }
  }

   async download(file: ReportAttachFile) {
    try {
      file.Loading = true;
      const pdf = await this.afService.getFile(file.Id);
      this.downloadLocalFileService.downLoadFile(pdf, file.Name, 'pdf');
    } catch (err) {
      this.notification.error(JSON.stringify(err.error), "Archivos adjuntos");
    } finally {
      file.Loading = false;
    }
  }

  uploadFile(event) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      const reader = new FileReader();
      reader.readAsDataURL(element);
      this.loading = true;
      reader.onload = async (_event) => {
        try {
          const base64Url =  <string>reader.result;
          let pdfBase64 = base64Url.split('base64,')[1];

          console.log(element.name);

          await this.afService.create(
            this.studyReportId,
            pdfBase64,
            element.name);

          await this.loadFiles();
        } catch (err) {
          this.notification.error(JSON.stringify(err.error), "Archivos adjuntos");
        } finally {
          this.loading = false;
        }
      }
    }
  }

}
